export function Footer() {
  return (
    <footer className="footer-vitals">
        <ul>
            <li>
                <a href="https://files.sdsigma.com/signosVitales/terminos_y_condiciones_signos_vitales_1.pdf" target="_blank" rel="noopener noreferrer">
                    Términos, condiciones y consentimiento informado
                </a>
            </li>
            <li>
                <a href="https://corporativo.sdsigma.com/policy?policy=tratamiento​" target="_blank" rel="noopener noreferrer">
                    Política de Tratamiento de datos
                </a>
            </li>
            <li>
                <span>
                    Derechos reservados
                </span>
            </li>
        </ul>
    </footer>
  )
}